import React, { useEffect, useRef } from 'react';
import './Newsletter.css';
import { initializeTracker } from '../tracker_script.js';

const Newsletter = () => {
  const formContainerRef = useRef(null);

  useEffect(() => {
    // Add meta tags to head
    const usernameMeta = document.createElement('meta');
    usernameMeta.name = 'username';
    usernameMeta.content = 'user_2o6eptKfyuvEOe6kSTFVnGzxmMU';
    document.head.appendChild(usernameMeta);

    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'Nomad Notes';
    document.head.appendChild(offerMeta);

    // Initialize the tracker
    try {
      initializeTracker();
      console.log('Tracker initialized successfully');
    } catch (error) {
      console.error('Error initializing tracker:', error);
    }

    // Remove any existing script first to avoid duplicates
    const existingScript = document.querySelector('script[data-uid="2ea899da02"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    // Create script element
    const script = document.createElement('script');
    script.src = 'https://tuomas-kivioja.kit.com/2ea899da02/index.js';
    script.async = true;
    script.setAttribute('data-uid', '2ea899da02');
    
    // Append script to the form container
    if (formContainerRef.current) {
      formContainerRef.current.appendChild(script);
    }
    
    // Cleanup function to remove script when component unmounts
    return () => {
      if (document.querySelector('script[data-uid="2ea899da02"]')) {
        document.querySelector('script[data-uid="2ea899da02"]').remove();
      }
      if (document.querySelector('meta[name="username"]')) {
        document.querySelector('meta[name="username"]').remove();
      }
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div className="newsletter-container">
      <div id="newsletter-form-container" ref={formContainerRef}>
        {/* Don't include the static script tag here, let the useEffect handle it */}
        {/* The script will be appended here dynamically */}
      </div>
    </div>
  );
};

export default Newsletter;
